export default class RegisterContoller {

  constructor(app) {
    this.app = app;
    this.pageId = "Register";
  }

  show(path, model) {
    const pageId = this.pageId;
    const app = this.app;

    if (!model) model = app;

    app.populate(pageId, model);
    app.swapPage(pageId);
  }
  register(name, email, password, avatar, emailSubscribe) {
    const app = this.app;
    if (!email) {
      app.createNotification("Error: Missing email");
      return;
    }
    if (!name) {
      app.createNotification("Error: Missing name");
      return;
    }
    if (!password) {
      app.createNotification("Error: Missing password");
      return;
    }

    app.createNotification("Registering...");
    if (email) email = email.trim();
    let userdata = {
      name: name,
      email: email,
      password: password,
      avatar: avatar,
      emailSubscribe: emailSubscribe
    };
    return app.accountJD.Register(userdata)
      .then(function (data) {
        if (!data || !data.id) return;
        if (data.id) app.userdata.id = data.id;
        if (data.name) app.userdata.name = data.name;
        if (data.email) app.userdata.email = data.email;
        if (data.facebookId) app.userdata.facebookId = data.facebookId;
        if (data.avatar) app.userdata.avatar = data.avatar;
        if (data.emailSubscribe) app.userdata.emailSubscribe = data.emailSubscribe;
        app.dataLoaded();
        app.save();
        app.createNotification("Login success");
      }.bind(this))
      .catch((e) => {
        app.createNotification("Error: Registering - " + e);
      });
  }
  avatarRandom() {
    const app = this.app;
    if (app.items && app.items.getRandomAvatar) {
      let avatar = app.items.getRandomAvatar();
      return avatar;
    }
  }
}
